import CustomDrawer from 'components/Drawer/drawer.cmp';
import CustomInput from 'components/Form/TextField/TextField.cmp';
import {
  CustomDrawerInnerCnt,
  TeamsDialog,
  DrawerHeaderCnt,
} from 'pages/teams/createTeamDrawer/createTeamDrawer.style';
import CloseIcon from '@mui/icons-material/Close';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { find, isEmpty, uniqueId } from 'lodash';
import {
  generateAssigneeDropdownData,
  statusDropdownData,
} from '../../../helper/task/dropdownData';
import { CustomSelect } from 'components/CustomSelect/CustomSelect';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import selectors from 'store/selectors';
import CustomButton from 'components/Button/CustomButton';
import xeniaApi from 'api/index';
import { createTeam, editTeam } from 'store/actions/teamActions';
import useUsers from 'utils/CustomHooks/useUsers';

function CreateTeamDrawer(props) {
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [teamName, setTeamName] = useState('');
  const { open, onClose, selectedEditTeam } = props;
  const dispatch = useDispatch();
  const userList = useSelector(selectors.getUserAdmin);
  const { taskAssignees } = useUsers();

  useEffect(() => {
    if (selectedEditTeam && open) {
      const filterSelectedMembers = membersDropdownData.filter((m) =>
        selectedEditTeam.Members.some((member) => member.MemberId == m.id),
      );
      setSelectedMembers(filterSelectedMembers);
      setTeamName(selectedEditTeam.name);
    }
  }, [open]);

  //Handle Team name input change
  const handleTeamNameInput = (e) => {
    const value = e?.target?.value;
    setTeamName(value);
  };
  //Updating member select
  const handleSelectMember = (option) => {
    setSelectedMembers(option);
  };

  //Generating Members data for dropdown
  const membersDropdownData = useMemo(() => {
    return generateAssigneeDropdownData(taskAssignees());
  }, [userList]);

  //On Create team button click
  const handleCreateTeam = async () => {
    const postData = {
      id: uniqueId(),
      name: teamName.trim(),
      Members: selectedMembers?.map((m) => m.id),
      isActive: true,
    };
    handleCloseDrawer();
    try {
      const newTeamObj = await xeniaApi.createTeam(postData);
      if (newTeamObj) dispatch(createTeam(newTeamObj.data));
      dispatch(editTeam(newTeamObj.data, postData));
    } catch (err) {
      /***/
    }
  };
  //On Update team button click
  const handleEditTeam = async () => {
    const postData = {
      id: selectedEditTeam.id,
      name: teamName.trim(),
      Members: selectedMembers?.map((m) => m.id),
      isActive: true,
    };
    handleCloseDrawer();
    const newTeamObj = await xeniaApi.editTeam(postData);
    dispatch(editTeam(newTeamObj.data));
  };
  const handleCloseDrawer = () => {
    onClose();
    setSelectedMembers([]);
    setTeamName('');
  };
  const addBtnDisabled = isEmpty(selectedMembers) || !teamName;

  const TeamsDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={handleCloseDrawer}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };

  return (
    <TeamsDialog onClose={handleCloseDrawer} open={open}>
      <CustomDrawerInnerCnt>
        <div className="headerCnt">
          <h2>{selectedEditTeam ? 'Edit Team' : 'Create Team'}</h2>
          <IconButton onClick={handleCloseDrawer}>
            <CloseIcon style={{ color: 'rgba(117, 113, 197, 1)' }} />
          </IconButton>
        </div>
        <div className="teamsDrawerContentCnt">
          <CustomInput
            label="Name"
            topLabelInput={true}
            muiLabel={false}
            id="teamNameInput"
            fieldProps={{ placeholder: 'Enter Team Name', value: teamName }}
            onChange={handleTeamNameInput}
          />
          <CustomSelect
            label={'Members'}
            placeholder="Select Members"
            isSearchable={true}
            isMulti={true}
            closeMenuOnSelect={false}
            selectedOption={selectedMembers}
            options={membersDropdownData.filter((o) => o.id != 'unassigned')}
            onChange={handleSelectMember}
          />
        </div>
        <div className="btnActionCnt">
          <CustomButton
            variant="text"
            buttonType={'gray'}
            style={{ marginRight: 16 }}
            onClick={handleCloseDrawer}
          >
            Cancel
          </CustomButton>
          <CustomButton
            variant="contained"
            disabled={addBtnDisabled}
            onClick={selectedEditTeam ? handleEditTeam : handleCreateTeam}
          >
            {selectedEditTeam ? 'Update' : 'Create'}
          </CustomButton>
        </div>
      </CustomDrawerInnerCnt>
    </TeamsDialog>
    // {/*<CustomDrawer open={open} onClose={handleCloseDrawer} size="medium">*/}
    // {/*  <CustomDrawerInnerCnt>*/}
    // {/*    <div className="headerCnt">*/}
    // {/*      <h2>Add Team</h2>*/}
    // {/*      <IconButton onClick={handleCloseDrawer}>*/}
    // {/*        <CloseIcon style={{ color: 'rgba(117, 113, 197, 1)' }} />*/}
    // {/*      </IconButton>*/}
    // {/*    </div>*/}
    // {/*    <div className="teamsDrawerContentCnt">*/}
    // {/*      <CustomInput*/}
    // {/*        label="Name"*/}
    // {/*        muiLabel={false}*/}
    // {/*        id="teamNameInput"*/}
    // {/*        fieldProps={{ placeholder: 'Enter Team Name', value: teamName }}*/}
    // {/*        onChange={handleTeamNameInput}*/}
    // {/*      />*/}
    // {/*      <CustomSelect*/}
    // {/*        label={'Members'}*/}
    // {/*        placeholder="Select Members"*/}
    // {/*        isMulti={true}*/}
    // {/*        selectedOption={selectedMembers}*/}
    // {/*        options={membersDropdownData.filter((o) => o.id != 'unassigned')}*/}
    // {/*        onChange={handleSelectMember}*/}
    // {/*      />*/}
    // {/*    </div>*/}
    // {/*    <div className="btnActionCnt">*/}
    // {/*      <CustomButton*/}
    // {/*        variant="text"*/}
    // {/*        style={{ marginRight: 16 }}*/}
    // {/*        onClick={onClose}*/}
    // {/*      >*/}
    // {/*        Cancel*/}
    // {/*      </CustomButton>*/}
    // {/*      <CustomButton*/}
    // {/*        variant="contained"*/}
    // {/*        disabled={addBtnDisabled}*/}
    // {/*        onClick={selectedEditTeam ? handleEditTeam : handleCreateTeam}*/}
    // {/*      >*/}
    // {/*        {selectedEditTeam ? 'Update' : 'Create'}*/}
    // {/*      </CustomButton>*/}
    // {/*    </div>*/}
    // {/*  </CustomDrawerInnerCnt>*/}
    // {/*</CustomDrawer>*/}
  );
}

export default CreateTeamDrawer;
